import { useState, useEffect } from "react";
import moment from "moment";

// HELPERS
import api from "@helpers/api";
import { dateToYearsMonthsDaysAgo } from "@helpers/utils";

const useCrmEventsCard = props => {
  const { client } = props;

  const [loaded, setLoaded] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [editEventModalOpen, setEditEventModalOpen] = useState(false);
  const [newEventAdded, setNewEventAdded] = useState(null);

  const updateEvents = event => {
    //check if event is due or active based on event end date
    const now = moment();
    const eventEnd = moment(event.endTime || event.EndTime);
    const isDue = eventEnd.isBefore(now);

    let lesEvents = [...(isDue ? events.past || [] : events.active || [])];

    // find existing index
    let index = lesEvents.findIndex(
      c =>
        (c.EventId && event.eventId && c.EventId === event.eventId) ||
        (c.eventId && event.eventId && c.eventId === event.eventId) ||
        (c.EventId && event.EventId && c.EventId === event.EventId)
    );

    const isNewEvent = index === -1;
    // if not found, add to end (new event)
    if (isNewEvent) {
      index = lesEvents.length;
      setNewEventAdded(event);

      // TODO: need to trigger highlight msg to show new event added
    }
    // update events with new event record
    lesEvents[index] = event;
    // sort by start time
    lesEvents.sort((a, b) => {
      // sort by start time ascending
      return moment(a.startTime || a.StartTime).isAfter(
        moment(b.startTime || b.StartTime)
      )
        ? 1
        : -1;
    });

    // if a event is selected, update it (edit from event modal)
    if (selectedEvent) setSelectedEvent(event);

    return setEvents({
      ...events,
      ...(isDue ? { past: [...lesEvents] } : { active: [...lesEvents] })
    });
  };

  const getEvents = async () => {
    try {
      let result = [];
      if (client?.id) {
        result = await api("client/events", {
          clientId: client.id
        });
      }
      setEvents(result);
      setLoaded(true);
    } catch (e) {
      console.error(e.message);
    }
  };

  const toggleEditEventModal = action => {
    if (!editEventModalOpen && (action === "add" || editEventModalOpen))
      setSelectedEvent(null);

    if (editEventModalOpen) {
      // disable/enable background content scrolling while modal is open
      document.documentElement.style.overflow = "auto";
    } else {
      document.documentElement.style.overflow = "hidden";
    }

    setEditEventModalOpen(!editEventModalOpen);
  };

  useEffect(() => {
    getEvents();
  }, []);

  return {
    loaded,
    client,
    events,
    selectedEvent,
    updateEvents,
    editEventModalOpen,
    toggleEditEventModal
  };
};

export default useCrmEventsCard;
